'use strict';

import * as T3_Ajax from './t3/_ajax';

const THEME__PREFIX						= 't3kk';
const THEME__PREFIX_SELECTOR			= '-'
const SELECTOR__CE						= '.ce';

const ACTION__ROOMS_AVAILABLE			= 'roomsAvailable';
const ACTION__SECTION_TEASER_MENU		= 'sectionTeaserMenu';

const ACTION__MONTH						= 'month';
const ACTION__CHECK_AVAILABILITY		= 'checkAvailability';

const ACTION__SET_VALUE_DATE_FROM		= "checkAvailability__set_date_from";
const ACTION__SET_VALUE_DATE_TO			= "checkAvailability__set_date_to";



function prefix(classname,attribute,is_selector) {
		
	var build = THEME__PREFIX+THEME__PREFIX_SELECTOR+classname;

	if(typeof(attribute) !== 'undefined' && attribute !== null) {
		build += '--'+attribute;
	}
	if(is_selector === true) {
		build = '.'+build;
	}

	return build;
	
};


/**
 * Params example:
 * ---
 * var params = {
 *		action: 'showMore',
 *		controller: 'Ajax,
 *		extension: 'tx_t3kkthemeberlinzimmer',
 *		typeNum: 85790
 * };
 */
const ajax__call = (
	params,
	caller,
	beforeSend,
	success
) => {
	ajax__handler(
		params,
		caller,
		beforeSend,
		success
	);
}

	
function ajax__handler(params,caller,beforeSend,success) {

	var data = T3_Ajax.buildData(params);

	console.log(data);


	$.ajax ({
		async: 'true',
		url: data,
		type: 'POST',
		dataType: 'json',
		data: {},
		beforeSend: function() {
			ajax_execute__beforeSend(
				params,
				caller,
				beforeSend
			);
		},
		success: function(data) {
			ajax_execute__onSuccess(
				params, 
				caller, 
				data,
				success
			);
		},
		error: function(xhr,e) {	
			var message = T3_Ajax.handleErrorMessage(xhr,e);
			switch(params["action"]) {
				case ACTION__SECTION_TEASER_MENU:
					break;
				default:
					
			}
		}
	});

}
	
	
	
function ajax_execute__beforeSend(params,caller,beforeSend) {

	switch(params.action) {
		case ACTION__SECTION_TEASER_MENU:
			break;
		default:;

	}
	
	if(typeof beforeSend === 'function') {
      beforeSend(params,caller);
    }
	

}
	

function ajax_execute__onSuccess(params,caller,data,success) {

	switch(params.action) {
		case ACTION__ROOMS_AVAILABLE:
			if(data.success) {
				caller.prepend(data.content);
				caller.find('.badge--available-rooms').addClass('t3kk-animate t3kk-animate--maintain t3kk-animate--rubber-band');
			}
			break;
		case ACTION__SECTION_TEASER_MENU:

			if(data.success) {
				caller.prepend(data.content);
			}
			break;
		default:

	}
	
	if(typeof success === 'function') {
      success(params,caller,data);
    }

}

function dialog__add_action(action) {
	$('body .t3kk-dialog').attr('data-action', action);
}
	

function dialog__add_content(content, duration, easing, bounce, effect) {
		
	if(typeof duration === 'undefined') {
		duration = 250;
	}
	if(typeof easing === 'undefined') {
		easing = 'spring';
	}
	if(typeof bounce === 'undefined') {
		bounce = false;
	}

	var button__close = '<div class="t3kk-button t3kk-button--icon t3kk-button--close"></div>';
	$('.t3kk-dialog .t3kk-dialog__content').html(
		button__close +
		JSON.parse(JSON.stringify(content))
	).promise().done(function(){

		if(typeof effect === 'undefined') {
			on__complete();
		} else {
			$('.t3kk-dialog .t3kk-dialog__front').velocity('slideDown', 
				{ 
					duration: duration,
					easing: easing,
					complete: function() {
						if(bounce === true) {
							$('.t3kk-dialog .t3kk-dialog__content').velocity("callout.bounce");
						}
						on__complete();
					}
				}
			);	
		}

	});

	function on__complete() {
		$('.t3kk-dialog .t3kk-dialog__overlay').removeClass('loading');
		dialog__show_button();
		
		$(document).on({
			click: function(event) {
				event.preventDefault();
				dialog__destroy(250,'spring', false, 'slideUp');
			}
		}, '.t3kk-dialog .t3kk-button.t3kk-button--icon.t3kk-button--close');
	}

}



function dialog__show(loader) {
	
	const SELECTOR__DIALOG = 'body .t3kk-dialog';
	
	if($(SELECTOR__DIALOG).length > 0) {
		$(SELECTOR__DIALOG).remove();
	}
	
	$('body').append(dialog__build(loader));
	
	$(SELECTOR__DIALOG).velocity("fadeIn", 
		{ 
			duration: 500,
			complete: function() {
				$('html').addClass('no-scrollbar');
			}
		}
	);
	
}



function dialog__show_button() {

	$('.t3kk-dialog .t3kk-button').velocity(
		'transition.fadeIn'
	);

}


function dialog__build(loader) {
	
	const CLASS_DIALOG = 't3kk-dialog';
	
	var classLoader = '';
	if(typeof loader !== 'undefined' && loader === true) {
		classLoader = ' loading loading--ripple';
	}

	var content = '<div class="'+CLASS_DIALOG+'__front"><div class="t3kk-wrap-table"><div class="t3kk-wrap-table__cell"><div class="'+CLASS_DIALOG+'__content"></div></div></div></div>';
	var overlay = '<div class="'+CLASS_DIALOG+'__overlay '+classLoader+'"></div>';

	var dialog = '<div class="'+CLASS_DIALOG+'">'+content+overlay+'</div>';

	return dialog;
	
}


function dialog__destroy(duration, easing, bounce, effect) {

	const CLASS__DIALOG = 't3kk-dialog';
	const SELECTOR__DIALOG = '.'+CLASS__DIALOG;

	if(typeof duration === 'undefined') {
		duration = 250;
	}
	if(typeof easing === 'undefined') {
		easing = 'spring';
	}
	if(typeof bounce === 'undefined') {
		bounce = true;
	}

	if(typeof effect === 'undefined') {
		effect = true;
	}

	if(bounce === false) {
		$(SELECTOR__DIALOG+' '+SELECTOR__DIALOG+'__content').velocity('callout.pulse', {
			complete: function() {
				__slideUp();
			}
		});
	} else {
		__slideUp();
	}

	function __slideUp() {
		$(SELECTOR__DIALOG+' '+SELECTOR__DIALOG+'__front').velocity('fadeOut',
			{ 
				duration: duration,
				easing: easing,
				complete: function() {
					$('body > .t3kk-dialog').velocity("fadeOut", 
						{ 
							duration: 500,
							complete: function() {
								$('html').removeClass('no-scrollbar');
								$('body > .t3kk-dialog').remove();
							}
						}
					);
				}
			}
		);
	}
}


function build__loader(loader, content) {
		
	if(typeof content === 'undefined') {
		content = '';
	}

	//return '<div class="t3kk-loader t3kk-loader--'+loader+'">'+content+'</div>';
	//return '<div class="sk-cube-grid"><div class="sk-cube sk-cube1"></div><div class="sk-cube sk-cube2"></div><div class="sk-cube sk-cube3"></div><div class="sk-cube sk-cube4"></div><div class="sk-cube sk-cube5"></div><div class="sk-cube sk-cube6"></div><div class="sk-cube sk-cube7"></div><div class="sk-cube sk-cube8"></div><div class="sk-cube sk-cube9"></div></div>';
	return '<div class="spinner"><div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div><div class="rect5"></div></div>';
}

export {
	ACTION__CHECK_AVAILABILITY,
	ACTION__ROOMS_AVAILABLE,
	ACTION__MONTH,
	ACTION__SECTION_TEASER_MENU,
	ACTION__SET_VALUE_DATE_FROM,
	ACTION__SET_VALUE_DATE_TO,
	prefix,
	ajax__call,
	build__loader,
	dialog__destroy,
	dialog__show
};